import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import { client } from "../../api/client";
import { commonConstants } from "../../constants";
import { globalConstants } from "../../constants/global.constants";

const policyAdapter = createEntityAdapter();

const initialState = policyAdapter.getInitialState({
  status: globalConstants.IDLE,
  policies: {},
  categories: {},
});

export const getProjectLabels = createAsyncThunk(
  "policy/getProjectLabels",
  async (thunkAPI) => {
    try {
      const response = await client.post("get_project_labels");
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const getLabelCategories = createAsyncThunk(
  "policy/getLabelCategories",
  async (thunkAPI) => {
    try {
      const response = await client.post("get_label_categories");
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const handleLabel = createAsyncThunk(
  "policy/handleLabel",
  async (labelData, thunkAPI) => {
    try {
      const response = await client.post("handle_label", labelData);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

const policySlice = createSlice({
  name: "policy",
  initialState,
  reducers: {},
  extraReducers: {
    [getProjectLabels.pending]: (state, action) => {
      state.status = globalConstants.LOADING;
    },
    [getProjectLabels.fulfilled]: (state, action) => {
      state.status = globalConstants.SUCCEEDED;
      state.policies = action.payload["allLabels"];
    },
    [getProjectLabels.rejected]: (state, action) => {
      state.status = globalConstants.ERROR;
    },
    [getLabelCategories.pending]: (state, action) => {
      state.status = globalConstants.LOADING;
    },
    [getLabelCategories.fulfilled]: (state, action) => {
      state.status = globalConstants.SUCCEEDED;
      state.categories = action.payload["allCategories"];
    },
    [getLabelCategories.rejected]: (state, action) => {
      state.status = globalConstants.ERROR;
    },
    [handleLabel.pending]: (state, action) => {
      state.status = globalConstants.LOADING;
    },
    [handleLabel.fulfilled]: (state, action) => {
      state.status = globalConstants.SUCCEEDED;
    },
    [handleLabel.rejected]: (state, action) => {
      state.status = globalConstants.ERROR;
    },
  },
});

export default policySlice.reducer;
